import { CurationStatus } from '@packages/enums';

export interface DataCurationUIState {
    documentFilters: {
        search: string | undefined;
        documentType: string[] | undefined;
        dateRange: [string, string] | undefined;
    };
}

export interface Curation {
    id: string;
    name: string;
    status: CurationStatus;
    progress: number;
    createdAt: string;
    cohortList: string[];
    selectionType: 'patient' | 'record';
    patientCount?: number;
    recordCount?: number;
    ontologyMethod: string;
}

export interface CurationStats {
    total: number;
    completed: number;
    inProgress: number;
    pending: number;
    failed: number;
}
